import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";

import CropFreeIcon from "@mui/icons-material/CropFree";
import AddIcon from "@mui/icons-material/Add";

import { actionAddAlert } from "../Alert";
import Tooltip from "@mui/material/Tooltip";
import { changeDrawMode } from "../Draw/DrawTools";

import { trackEvent } from "../../tracking";

const widget_ = (theme) => ({
  // 44x44 min size is needed to meet this accessibility requirement:
  // https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html
  width: 44,
  height: 44,
  minWidth: "unset",
  backgroundColor: "#ffffff",
  border: "1px solid #f0f0f0",
  [theme.breakpoints.down("sm")]: {
    width: 34,
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
  },
});

const zoomBox_ = (theme) => ({
  marginBottom: "2px",
  [theme.breakpoints.down("sm")]: {
    display: "none !important",
  },
});

const zoomboxActive_ = (theme) => ({
  backgroundColor: "#4555b5",
  color: "white !important",
});

export default function ZoomBox() {
  const MODE = "draw_zoom_box";

  const dispatch = useDispatch();
  const drawMode = useSelector((state) => state.mapReducer.drawMode);
  const { mode } = drawMode;
  const modeIsActive = mode === MODE;

  const zoomBoxClickHandler = () => {
    changeDrawMode(MODE, dispatch, drawMode);
  };

  useEffect(() => {
    if (modeIsActive) {
      dispatch(
        actionAddAlert({
          id: "draw",
          title:
            "Zoom Box - Click Once On the Map, Move the Cursor to Size the Box, then Click Again to Complete",
          onClose: zoomBoxClickHandler,
        }),
      );
      trackEvent({
        category: "Map Widget",
        action: "Zoom Box Tool",
      });
    }
  }, [dispatch, modeIsActive]);

  return (
    <>
      <Tooltip title="Zoom Box">
        <Button
          variant="contained"
          sx={[widget_, zoomBox_, drawMode.mode === MODE && zoomboxActive_]}
          onClick={zoomBoxClickHandler}
        >
          <CropFreeIcon style={{ fontSize: "1.75rem" }} />
          <AddIcon style={{ fontSize: "1.2rem", position: "absolute" }} />
        </Button>
      </Tooltip>
    </>
  );
}
